import { ConditionalText, DateTimeCell } from '@shared/components'
import { Descriptions, Divider, Modal, Table } from 'antd'

import { ColumnsType } from 'antd/es/table'
import { DescriptionsProps } from 'antd/lib'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { CommonApplicationsProps } from './types'
import { returnRenderValue } from './utils'

export const PreviewApplicationsLog = ({
  data,
  ...props
}: CommonApplicationsProps) => {
  const { t } = useTranslation()

  const items: DescriptionsProps['items'] = [
    {
      label: t('common.modifier'),
      children: data?.modifier?.full_name
    },
    {
      label: t('form.item.email'),
      children: data?.modifier?.email
    },
    {
      label: t('form.placeholder.app_name'),
      children: data?.application_name
    },
    {
      label: t('table.type'),
      children: t(`log_type.${data?.type}`)
    },
    {
      label: t('table.model'),
      children: data?.model
    },
    {
      label: t('table.date_created'),
      children: <DateTimeCell date={data?.timestamp} />
    }
  ]

  const dataSource = useMemo(
    () =>
      Object.entries(data?.data || {}).map(([key, value]) => ({
        title: key,
        ...value
      })),
    [data]
  )

  const columns: ColumnsType<(typeof dataSource)[number]> = [
    {
      title: t('common.field_name'),
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: t('common.old_value'),
      dataIndex: 'old',
      key: 'old',
      render: (value) => (
        <ConditionalText condition={!!value}>
          {returnRenderValue(value)}
        </ConditionalText>
      )
    },
    {
      title: t('common.new_value'),
      dataIndex: 'new',
      key: 'new',
      render: (value) => (
        <ConditionalText condition={!!value}>
          {returnRenderValue(value)}
        </ConditionalText>
      )
    }
  ]

  return (
    <Modal
      width={800}
      title={t('details')}
      onOk={props.onCancel}
      cancelButtonProps={{ hidden: true }}
      {...props}
    >
      <Descriptions
        column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
        items={items}
      />

      <Divider />

      <Table dataSource={dataSource} columns={columns} pagination={false} />
    </Modal>
  )
}
